class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    setTimeout(()=>{
       this.handleOneAssistCheckbox();
    })

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    console.log("Render contents called ", parsedState);
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.handleOneAssistCheckbox();
      this.open();
    });
  }

   handleOneAssistCheckbox() {
    console.log("Checkbox logic called")
    const ampleCheckboxWrapper = document.getElementById('applecare-checkbox-wrapper');
    const ampleCheckbox = document.getElementById('applecare-acknowledge');
    const oneAssistCheckboxWrapper = document.getElementById('oneassist-checkbox-wrapper');
    const oneAssistCheckbox = document.getElementById('oneassist-acknowledge');
    const checkoutBtn = document.getElementById('CartDrawer-Checkout');
    const viewCartBtn =
      document.querySelector('.drawer__footer .view-btn') || document.querySelector('a.view-btn');

      if (!ampleCheckboxWrapper || !ampleCheckbox || !oneAssistCheckboxWrapper || !oneAssistCheckbox  || !checkoutBtn) {
        console.warn('AppleCare elements not found in DOM');
        return;
      }

      ampleCheckboxWrapper.style.display = 'none';
      oneAssistCheckboxWrapper.style.display = 'none';
      checkoutBtn.disabled = false;
      checkoutBtn.style.opacity = '1';
      checkoutBtn.style.cursor = 'pointer';
      if (ampleCheckbox) ampleCheckbox.checked = false;
      if (oneAssistCheckbox) oneAssistCheckbox.checked = false;

      const hasOneAssistWarranty = document.querySelector('[id^="One Assist Warranty"]');
      const hasAmpleCare = document.querySelector('[id^="Ample Care Variant"]');

      if (hasOneAssistWarranty || hasAmpleCare) {
        ampleCheckboxWrapper.style.display = 'flex';
        oneAssistCheckboxWrapper.style.display = 'flex';
        checkoutBtn.disabled = true;
        checkoutBtn.style.opacity = '0.5';
        checkoutBtn.style.cursor = 'not-allowed';

        // Hide view cart button
        if (viewCartBtn) {
          Object.assign(viewCartBtn.style, {
            visibility: 'hidden',
            height: '0',
            overflow: 'hidden',
            margin: '0',
            padding: '0',
          });
        }

        if (ampleCheckbox && ampleCheckbox.parentNode) {
          ampleCheckbox.addEventListener('change', () => {
            const isAmpleChecked = ampleCheckbox.checked;
            const isOneAssistChecked = oneAssistCheckbox.checked;

            const isChecked = isAmpleChecked && isOneAssistChecked;

            checkoutBtn.disabled = !isChecked;
            checkoutBtn.style.opacity = isChecked ? '1' : '0.5';
            checkoutBtn.style.cursor = isChecked ? 'pointer' : 'not-allowed';

            if (viewCartBtn) {
              Object.assign(viewCartBtn.style, isChecked
                ? { visibility: 'visible', height: 'auto', overflow: 'visible' }
                : { visibility: 'hidden', height: '0', overflow: 'hidden' }
              );
            }
          });
        } else {
          console.warn('Ample Checkbox element or its parent node not found when trying to replace it.');
        }

        if (oneAssistCheckbox && oneAssistCheckbox.parentNode) {
          oneAssistCheckbox.addEventListener('change', () => {
            const isOneAssistChecked = oneAssistCheckbox.checked;

            const isAmpleChecked = ampleCheckbox.checked;

            const isChecked =  isAmpleChecked && isOneAssistChecked;

            checkoutBtn.disabled = !isChecked;
            checkoutBtn.style.opacity = isChecked ? '1' : '0.5';
            checkoutBtn.style.cursor = isChecked ? 'pointer' : 'not-allowed';

            if (viewCartBtn) {
              Object.assign(viewCartBtn.style, isChecked
                ? { visibility: 'visible', height: 'auto', overflow: 'visible' }
                : { visibility: 'hidden', height: '0', overflow: 'hidden' }
              );
            }
          });
        } else {
          console.warn('One Assist Checkbox element or its parent node not found when trying to replace it.');
        }


      } else {
        ampleCheckboxWrapper.style.display = 'none';
        oneAssistCheckboxWrapper.style.display = 'none';
        checkoutBtn.disabled = false;
        checkoutBtn.style.opacity = '1';
        checkoutBtn.style.cursor = 'pointer';
        if (ampleCheckbox) ampleCheckbox.checked = false;
        if (oneAssistCheckbox) oneAssistCheckbox.checked = false;

        if (viewCartBtn) {
          Object.assign(viewCartBtn.style, {
            visibility: 'visible',
            height: 'auto',
            overflow: 'visible',
            margin: '',
            padding: '',
          });
        }
      }
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
   
  handleOneAssistCheckbox() {
    console.log("Checkbox logic called")
    const ampleCheckboxWrapper = document.getElementById('applecare-checkbox-wrapper');
    const ampleCheckbox = document.getElementById('applecare-acknowledge');
    const oneAssistCheckboxWrapper = document.getElementById('oneassist-checkbox-wrapper');
    const oneAssistCheckbox = document.getElementById('oneassist-acknowledge');
    const checkoutBtn = document.getElementById('CartDrawer-Checkout');
    const viewCartBtn =
      document.querySelector('.drawer__footer .view-btn') || document.querySelector('a.view-btn');

      if (!ampleCheckboxWrapper || !ampleCheckbox || !oneAssistCheckboxWrapper || !oneAssistCheckbox  || !checkoutBtn) {
        console.warn('AppleCare elements not found in DOM');
        return;
      }

      ampleCheckboxWrapper.style.display = 'none';
      oneAssistCheckboxWrapper.style.display = 'none';
      checkoutBtn.disabled = false;
      checkoutBtn.style.opacity = '1';
      checkoutBtn.style.cursor = 'pointer';
      if (ampleCheckbox) ampleCheckbox.checked = false;
      if (oneAssistCheckbox) oneAssistCheckbox.checked = false;

      const hasOneAssistWarranty = document.querySelector('[id^="One Assist Warranty"]');
      const hasAmpleCare = document.querySelector('[id^="Ample Care Variant"]');

      if (hasOneAssistWarranty || hasAmpleCare) {
        ampleCheckboxWrapper.style.display = 'flex';
        oneAssistCheckboxWrapper.style.display = 'flex';
        checkoutBtn.disabled = true;
        checkoutBtn.style.opacity = '0.5';
        checkoutBtn.style.cursor = 'not-allowed';

        // Hide view cart button
        if (viewCartBtn) {
          Object.assign(viewCartBtn.style, {
            visibility: 'hidden',
            height: '0',
            overflow: 'hidden',
            margin: '0',
            padding: '0',
          });
        }

        if (ampleCheckbox && ampleCheckbox.parentNode) {
          ampleCheckbox.addEventListener('change', () => {
            const isAmpleChecked = ampleCheckbox.checked;
            const isOneAssistChecked = oneAssistCheckbox.checked;

            const isChecked = isAmpleChecked && isOneAssistChecked;

            checkoutBtn.disabled = !isChecked;
            checkoutBtn.style.opacity = isChecked ? '1' : '0.5';
            checkoutBtn.style.cursor = isChecked ? 'pointer' : 'not-allowed';

            if (viewCartBtn) {
              Object.assign(viewCartBtn.style, isChecked
                ? { visibility: 'visible', height: 'auto', overflow: 'visible' }
                : { visibility: 'hidden', height: '0', overflow: 'hidden' }
              );
            }
          });
        } else {
          console.warn('Ample Checkbox element or its parent node not found when trying to replace it.');
        }

        if (oneAssistCheckbox && oneAssistCheckbox.parentNode) {
          oneAssistCheckbox.addEventListener('change', () => {
            const isOneAssistChecked = oneAssistCheckbox.checked;

            const isAmpleChecked = ampleCheckbox.checked;

            const isChecked =  isAmpleChecked && isOneAssistChecked;

            checkoutBtn.disabled = !isChecked;
            checkoutBtn.style.opacity = isChecked ? '1' : '0.5';
            checkoutBtn.style.cursor = isChecked ? 'pointer' : 'not-allowed';

            if (viewCartBtn) {
              Object.assign(viewCartBtn.style, isChecked
                ? { visibility: 'visible', height: 'auto', overflow: 'visible' }
                : { visibility: 'hidden', height: '0', overflow: 'hidden' }
              );
            }
          });
        } else {
          console.warn('One Assist Checkbox element or its parent node not found when trying to replace it.');
        }


      } else {
        ampleCheckboxWrapper.style.display = 'none';
        oneAssistCheckboxWrapper.style.display = 'none';
        checkoutBtn.disabled = false;
        checkoutBtn.style.opacity = '1';
        checkoutBtn.style.cursor = 'pointer';
        if (ampleCheckbox) ampleCheckbox.checked = false;
        if (oneAssistCheckbox) oneAssistCheckbox.checked = false;

        if (viewCartBtn) {
          Object.assign(viewCartBtn.style, {
            visibility: 'visible',
            height: 'auto',
            overflow: 'visible',
            margin: '',
            padding: '',
          });
        }
      }
  }

  // getSectionsToRender() {
    
  //   return [
     
  //   ];
  // }
}

customElements.define('cart-drawer-items', CartDrawerItems);
